import { Scheduler } from '@mummssoftware/utils';

export type FetchCarePlanFrequenciesParams = {
  scheduler: Scheduler;
  agency: string;
  siteId: string;
  patientNumber: string;
  fromDate: string;
  toDate: string;
};

export const fetchCarePlanFrequencies = async ({
  scheduler,
  agency,
  siteId,
  patientNumber,
  fromDate,
  toDate,
}: FetchCarePlanFrequenciesParams): Promise<
  mumms.patientCarePlanProblemFrequency[]
> => {
  const response = await scheduler.getPatientCarePlanFrequencies(
    agency,
    siteId,
    agency,
    patientNumber,
    undefined,
    fromDate,
    toDate,
  );

  if (response instanceof Response) {
    return [];
  }

  return response as mumms.patientCarePlanProblemFrequency[];
};
